import React from 'react';
import { Link } from 'gatsby';

import './AlertSidebar.scss';


const AlertSidebar = () => {
  return (
    <div className="SideBar">
      <div className="SideBar__main">
          <h6>Account Manager</h6>
          <h6>Key actions</h6>
          <h6>Notifications</h6>
      </div>
    </div>
  );
};

export default AlertSidebar;